import api from "../../../services/api";

/**
 * venusBillingService - Handles multiple Bank and Digital payment accounts.
 */

// Banks
export const getBanks = () => api.get("/venus-billing/banks");
export const createBank = (data) => api.post("/venus-billing/banks", data);
export const updateBank = (id, data) => api.patch(`/venus-billing/banks/${id}`, data);
export const deleteBank = (id) => api.delete(`/venus-billing/banks/${id}`);

// Digital Payments
export const getDigitalPayments = () => api.get("/venus-billing/digital");
export const createDigitalPayment = (data) => api.post("/venus-billing/digital", data);
export const updateDigitalPayment = (id, data) => api.patch(`/venus-billing/digital/${id}`, data);
export const deleteDigitalPayment = (id) => api.delete(`/venus-billing/digital/${id}`);




